var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.259,
    height: 24.267,
    viewBox: "0 0 24.259 24.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23280",
    "data-name": "Group 23280",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13932",
    "data-name": "Path 13932",
    d: "M-6088.692,4281.2l-6.746-6.746c-.558-.558-1.1-1.128-1.682-1.663-.134-.124-.38-.123-.573-.185a2.693,2.693,0,0,1-1-.344c-1.023-.952-1.991-1.965-2.936-2.912l2.445-2.429c.962.948,2.017,1.96,3.031,3.011a1.018,1.018,0,0,1,.235.8.8.8,0,0,0,.315.824c2.72,2.719,5.436,5.442,8.205,8.216l.924-.924c.557-.558,1.025-.665,1.478-.337s.516.789.156,1.53l4.193,4.183c.331.329.663.657.991.99a2.6,2.6,0,0,1,.081,3.685,2.581,2.581,0,0,1-3.718-.022q-2.457-2.424-4.882-4.881c-.208-.208-.352-.344-.678-.153a.922.922,0,0,1-1.159-.312,1,1,0,0,1,.1-1.243,7.834,7.834,0,0,1,.581-.579C-6089.142,4281.536-6088.932,4281.388-6088.692,4281.2Z",
    transform: "translate(6102.302 -4265.414)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13933",
    "data-name": "Path 13933",
    d: "M-5985.434,4263.7l-3.371-3.365c.438-.43.931-.882,1.381-1.373a1.238,1.238,0,0,0,.3-.666c.072-.736.091-1.478.129-2.217a4.076,4.076,0,0,1,1.363-2.993,6.042,6.042,0,0,1,2.846-1.73,2.4,2.4,0,0,1,1.979.562c.411.336.429.635.058,1.014-.644.655-1.3,1.3-1.944,1.949a1.021,1.021,0,0,0,0,1.667c.462.471.926.941,1.4,1.4a.988.988,0,0,0,1.563-.009c.655-.643,1.3-1.3,1.951-1.943.435-.431.733-.408,1.114.07a2.547,2.547,0,0,1,.169,2.9,15.4,15.4,0,0,1-1.178,1.648,4.3,4.3,0,0,1-3.142,1.581c-.738.047-1.478.073-2.217.119a1.086,1.086,0,0,0-.509.106C-5984.187,4262.836-5984.823,4263.282-5985.434,4263.7Z",
    transform: "translate(6000.375 -4251.321)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13934",
    "data-name": "Path 13934",
    d: "M-6100.336,4379.868l3.29,3.281c-.23.44-.459.89-.7,1.334a1.373,1.373,0,0,1-.242.3q-3.071,3.074-6.147,6.144a2.465,2.465,0,0,1-2.708.627,2.439,2.439,0,0,1-1.7-2.145,2.29,2.29,0,0,1,.614-1.963c2.5-2.529,5.022-5.036,7.538-7.55A.1.1,0,0,1-6100.336,4379.868Z",
    transform: "translate(6108.566 -4367.449)",
    fill: "#9d9d9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultations);
export default __webpack_public_path__ + "static/media/consultations.728b2b92bff6cfb1848c6af19d2f62ea.svg";
export { ForwardRef as ReactComponent };